var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-heartEmpty_svg__a",
    d: "M20.484 6.387a6.004 6.004 0 00.277-1.8C20.755 2.437 19.05.58 16.655.111c-2.395-.468-4.84 1.263-5.888 3.207C9.707 1.375 7.254-.35 4.857.127 2.461.603.76 2.47.761 4.623c.044.967.31 1.916.781 2.79.25.496.542.974.873 1.431.718.892 1.504 1.74 2.353 2.538.832.855 1.695 1.692 2.557 2.52 1.028.99 2.055 1.971 3.164 2.916l.37.315.36-.315a89.92 89.92 0 004.95-4.698 33.654 33.654 0 002.887-3.033 8.414 8.414 0 001.428-2.7z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillRule: "nonzero",
    stroke: "#093F45",
    strokeWidth: 2,
    xlinkHref: "#icon-heartEmpty_svg__a",
    transform: "translate(1 1)",
    fill: "#fff"
  })));
}

export default SvgIconHeartEmpty;